const modalCalendarEvent = (state) => state.modalCalendarEvent;
const hasModalCalendarEvent = (state) => state.modalCalendarEvent !== null;
const modalAppointment = (state) => state.modalAppointment;
const hasModalAppointment = (state) => state.modalAppointment !== null;

export default {
  modalCalendarEvent,
  hasModalCalendarEvent,
  modalAppointment,
  hasModalAppointment,
};
